<template>
<div id="E0-0" class="sub">
  <div class="wrapper">
    <kg-header :headerType=1 />
    <kg-category-panel @selectCategoryEvent="selectCategory($event)"/>
  </div>
</div>
</template>

<script>
import * as App from '../../utils/App'
import {KG_STORAGE_KEY} from '../../constants/App'

// kaggul Module
import Header from '../components/common/HomeIconHeader'
import CategoryPanel from '../components/planning/CategoryPanel'

export default {
  components: {
    'kg-header': Header,
    'kg-category-panel': CategoryPanel
  },
  methods: {
    selectCategory: function (category) {
      // ローカルストレージを削除
      App.removeLocalStorage(KG_STORAGE_KEY.SELECT_CATEGORY_DATA)
      App.removeLocalStorage(KG_STORAGE_KEY.SELECT_STYLE_DATA)
      App.removeLocalStorage(KG_STORAGE_KEY.SELECT_PLAN_DATA)
      App.removeLocalStorage(KG_STORAGE_KEY.ORDER_INFO)
      App.removeLocalStorage(KG_STORAGE_KEY.ORDER_INPUT)
      App.removeLocalStorage(KG_STORAGE_KEY.OPTION_SERVICE_LIST)
      // カテゴリ選択時の処理
      // 選択されたカテゴリーをストレージにセットしてから画面遷移
      App.setLocalStorage(KG_STORAGE_KEY.SELECT_CATEGORY_DATA, category)
      this.$router.push('/kagull/planning/select')
    }
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/FpCategory.vue